export class BankData{
    bankId: number;
    agency: string;
    number: string;
    digit: string;
    type: number;
    coOwnerName: string;
    coOwnerCPF: string;
    idCustomer: number;
}